var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4856 0.0568977L0.836722 4.15164C0.355546 4.28508 0.0154512 4.73296 0.000511286 5.25287C-0.0144286 5.77278 0.299336 6.24117 0.771984 6.40453L6.50882 8.41288C6.55105 8.42965 6.58512 8.46337 6.60344 8.50653L8.71491 14.2298C8.88991 14.7007 9.32705 15.008 9.81048 14.9998H9.84036C10.3326 14.9982 10.7684 14.6668 10.921 14.1778L14.9448 1.55535C15.0733 1.14353 14.9737 0.691197 14.6858 0.379482C14.3775 0.0413176 13.9118 -0.0838572 13.4856 0.0568977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendV2);
export default __webpack_public_path__ + "static/media/Send_v2.5375a1c4.svg";
export { ForwardRef as ReactComponent };